<script>
	/*
		TCareInput.svelte
	*/


	export let source;
	export let prop;
	export let setValue;
	export let placeholder;

	
	const _onKeyUp = (e) => {
		setValue(source, prop, e.target.value);
	}

</script>

<style>
	/* in tcare-ui.css */
</style>

<div class="tcui-control flex-row">
	<input class="input" value={source[prop]} on:keyup={_onKeyUp} placeholder={placeholder} />
</div>
